/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import { CountdownBanner, Footer, Nav } from "../components";

export default function Layout({ children, ...rest }) {
  return (
    <div className={"Layout"}>
      <Nav />
      <CountdownBanner {...rest} />
      {children}
      <Footer />
    </div>
  );
}
